import Pusher from "pusher-js";
import LaravelEcho from "laravel-echo";

export const events = [
    // Notifications
    "notification.problem-reported",
    "notification.problem-upvoted",
    "notification.task-assigned",
    "notification.task-comment",
    "notification.comment-tagged",

    // Tasks
    "task.described",
    "task.added",
    "task.created",
    "task.deleted",
    "task.category-auto-detected",
    "task.assigned-to-category",
    "task.assigned-to-user",
    "task.assignees-cleared",
    "task.category-cleared",
    "task.located",
    "task.priority-auto-detected",
    "task.priority-changed",
    "task.reopened",
    "task.restored",
    "task.unscheduled",
    "task.completed",
    "task.scheduled",
    "task.tagged",
    "task.untagged",
    "task.visibility-toggled",

    // Checklists
    "checklist.created",
    "checklist.deleted",
    "checklist-item.created",
    "checklist-item.deleted",
    "checklist-item.checked",
    "checklist-item.unchecked",
];

window.Pusher = Pusher;
export const Echo = new LaravelEcho({
    broadcaster: "pusher",
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    wssPort: process.env.MIX_PUSHER_PORT,
    forceTLS: process.env.MIX_PUSHER_FORCE_TLS,
    encrypted: true,
    disableStats: true,
    enabledTransports: ["ws", "wss"],
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    namespace: null,
});
